var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenachrichtigung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Benachrichtigung__Icn/40px/Benachrichtigung",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Benachrichtigung__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Benachrichtigung__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28,10 C29.1045695,10 30,10.8954305 30,12 L30,28 C30,29.1045695 29.1045695,30 28,30 L12,30 C10.8954305,30 10,29.1045695 10,28 L10,12 C10,10.8954305 10.8954305,10 12,10 L28,10 Z M28,12 L12,12 L12,28 L28,28 L28,12 Z M21.5,23 L21.5,26 L18.5,26 L18.5,23 L21.5,23 Z M21.5,14 L21.5,21 L18.5,21 L18.5,14 L21.5,14 Z",
    id: ".._.._src_svg_Icn_40px_Benachrichtigung__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenachrichtigung);
export default __webpack_public_path__ + "static/media/Benachrichtigung.eb2b368fd398635f213607e13e601d42.svg";
export { ForwardRef as ReactComponent };